module.exports = __webpack_public_path__ + "img/logo.17163b80.png";